<template>
  <notification-layout
    :icon="notification.icon"
    :time="notification.notify_at"
    :notification="notification"
    @deleteNotification="deleteNotification"
  >
    {{ notification.textBeforeLinks }}
    <router-link class="hover-orange" :to="notification.firstLinkTo">{{
      notification.firstLinkText
    }}</router-link>
    {{ notification.textBetweenLinks }}
    <router-link class="hover-orange" :to="notification.secondLinkTo">{{
      notification.secondLinkText
    }}</router-link>
    {{ notification.textAfterLinks }}
  </notification-layout>
</template>
<script>
import NotificationLayout from "./NotificationLayout.vue";
export default {
  components: { NotificationLayout },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteNotification(id) {
      this.$emit("deleteNotification", id);
    },
  },
};
</script>
